import { Link, Typography } from '@mui/material';

/**
 * The footer both statement group panels close with: a nudge to disconnect accounts the member
 * doesn't use for business, rather than keep being asked for their statements.
 *
 * Props-free on purpose. It existed as two byte-identical copies, and every prop that could be
 * added here — a link target, a variant — is a way for the two panels to start saying different
 * things about the same settings page. Lives under `customComponents` rather than
 * `modules/common/` because both consumers are group panels and the copy is bank-statement
 * specific; `common/` is for the domain-free.
 */
export default function UnusedAccountsHint() {
    return (
        <Typography variant="body2" color="text.secondary">
            Not using any of these accounts for business? Disconnect unused accounts in your{' '}
            <Link href="/settings/bank-accounts" target="_blank" rel="noopener noreferrer" color="primary">
                settings page
            </Link>{' '}
            to keep your bookkeeping accurate.
        </Typography>
    );
}
